import React, { Component } from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import * as POSSelectors from 'PointOfSale/selectors';
import GroupTeacherSideBar from 'PointOfSale/modules/groupTeacher/component/GroupTeacherSideBar';
import {
  toggleAllForCheckout,
  setSelectAllStudents,
} from 'PointOfSale/modules/teacher/state/actions';

class TeacherSideBarContainer extends Component {
  toggleAllStudents = () => {
    const {
      toggleAllForCheckout,
      students,
      selectAllStudents,
      setSelectAllStudents,
    } = this.props;
    if (students.length === 0) {
      return;
    }
    const nextState = !selectAllStudents;
    setSelectAllStudents(nextState);
    toggleAllForCheckout(nextState);
  };

  render() {
    const { teacher, students, selectAllStudents } = this.props;
    return (
      <React.Fragment>
        <GroupTeacherSideBar
          teacher={teacher}
          toggle={this.toggleAllStudents}
          toggleSelected={selectAllStudents && students.length > 0}
        />
      </React.Fragment>
    );
  }
}

TeacherSideBarContainer.propTypes = {
  teacher: PropTypes.string,
  selected: PropTypes.object,
};

const mapStateToProps = state => ({
  teacher: POSSelectors.getTeacher(state),
  students: POSSelectors.getStudentsForTeacher(state),
  selectAllStudents: POSSelectors.getSelectAllStudents(state),
});

const mapDispatchToProps = {
  toggleAllForCheckout,
  setSelectAllStudents,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TeacherSideBarContainer);



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/teacher/container/TeacherSideBarContainer.js